// import Pic from "../../../assets/image/image10.png";
import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import Typical from "react-typical";
import portfolioPic from "../../../assets/image/personal-pic/my-bg-5.png";
import './Introduction.scss';

const Introduction = () => {
  return (
    <>
      <div className="introduction">
        <Container className="mt-5">
          <Row className="align-items-center">
            <Col md={6} sm={12} className="pb-4">
              <Card.Body>
                <h4>Hello, I'm Nurul Alam.</h4>
                <Typical
                  steps={[
                    "A JavaScript Developer.",
                    2000,
                    "A React Js Developer.",
                    2000,
                    "A Vue Js Developer.",
                    2000,
                    "A Full-Stack Developer",
                    2000,
                  ]}
                  loop={Infinity}
                  wrapper="h4"
                />
                <p>
                  As a JavaScript and Node Js developer, I have design,
                  developed, and launched highly customized responsive website
                  and e-commerce solutions using advanced technologies.
                </p>
                <button>
                  <a href="https://drive.google.com/uc?export=download&id=1LFKk9eaPZrcywo7ErX2XbSGjPvSLrUCY">
                    Download Resume
                  </a>
                </button>
              </Card.Body>
            </Col>
            <Col className="pb-4" md={6} sm={12}>
              <div className="d-flex justify-content-end">
                <img className="w-100 resize-image" src={portfolioPic} alt="" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 220">
        <path
          fill="#100028"
          fillOpacity="1"
          d="M0,160L1440,96L1440,0L0,0Z"
        ></path>
      </svg>
    </>
  );
};

export default Introduction;
